var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandWithFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ecology-Plant-Hand--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.19189 21.0728V36.0728",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.1919 33.5894C26.1919 32.2633 25.6651 30.9915 24.7274 30.0538C23.7897 29.1161 22.518 28.5894 21.1919 28.5894H14.8752C14.8752 27.2633 14.3484 25.9915 13.4108 25.0538C12.4731 24.1161 11.2013 23.5894 9.87523 23.5894H1.19189V33.5894H26.1919Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.94189 28.5728H14.9419",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.875 13.5895C19.875 13.5895 17.325 17.9562 13.625 17.3395C6.125 16.0895 7.375 6.08954 4.875 2.33954C7.29804 1.35662 9.91836 0.957613 12.5241 1.17476C15.1299 1.39191 17.6481 2.21913 19.875 3.58954C23.6917 6.07288 23.6917 9.82288 19.875 13.5895Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.2085 17.2397C28.2085 17.2397 29.8752 20.2563 32.4918 19.8397C37.6918 18.973 36.8252 12.0397 38.5585 9.423C36.8877 8.74569 35.0818 8.46831 33.2847 8.613C31.4877 8.75768 29.7494 9.32043 28.2085 10.2563C25.5418 12.0397 25.5418 14.6397 28.2085 17.2397Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.875 8.5896C14.875 8.5896 21.125 9.8396 23.625 22.3396C25.0821 19.3735 27.2245 16.7969 29.875 14.8229",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWithFlower);
export default __webpack_public_path__ + "static/media/handWithFlower.bf01037a88b71ab5eb6fa6144027b2cf.svg";
export { ForwardRef as ReactComponent };